module.exports = __webpack_public_path__ + "media/images/growth_mindset/choosing-growth-mindset-231429ee4d789ad351bf531c04e9f785.png";